"use client";
import React from "react";
import TopBar from "./../components/common/TopBar";
import Footer from "./../components/Footer";
import HeroSection from "./../components/home/HeroSection";
import FeaturesSection from "./../components/home/FeaturesSection";
import PopularTopicsSection from "./../components/home/PopularTopicsSection";
import CommunityStatsSection from "./../components/home/CommunityStatsSection";
import JoinCommunitySection from "./../components/home/JoinCommunitySection";

const HomePage = () => {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <TopBar />

      <main className="flex-1">
        <HeroSection />
        <FeaturesSection />
        <PopularTopicsSection />
        <CommunityStatsSection />
        <JoinCommunitySection />
      </main>

      <Footer />
    </div>
  );
};

export default HomePage;
